export const featurePages = {
    index: {
        metaTitle: "ফিচার",
        eyebrow: "ফিচার",
        title: "বাংলাদেশের দোকান চালাতে যা লাগে, সব এক সিস্টেমে",
        body: "দোকানের কাউন্টার, ফেসবুক আর ওয়েবসাইটের অর্ডার, কুরিয়ার, সব ব্রাঞ্চের স্টক আর তার হিসাব — সবাই একই স্টক আর একই হিসাব দেখে।",
        more: "বিস্তারিত দেখুন",
    },
    common: {
        seeLive: "চালু অবস্থায় দেখুন",
        seeLiveBody: "একটি আসল ডেমো দোকান খুলে দেখুন, অথবা অ্যাডমিন আর POS সহ নিজের একটি ডেমো ব্যবসা নিন — সাইন আপ ছাড়াই।",
        visitShop: "চালু ডেমো দোকানটি দেখুন",
        tryIt: "নিজে চালিয়ে দেখুন",
        related: "{{brand}}-এ আরও আছে",
        forIndustries: "যাদের জন্য",
    },
    pos: {
        nav: "POS",
        metaDescription: "উইন্ডোজ আর ম্যাকের জন্য অফলাইনেও চলা POS: বারকোড স্ক্যান, বাংলা রসিদ, বিল হোল্ড, রিটার্ন, শিফট আর ক্যাশ গোনা — অনলাইনের স্টকের সাথে মিলিয়ে।",
        eyebrow: "পয়েন্ট অব সেল",
        title: "যে কাউন্টারে বিল কখনো থামে না",
        body: "কাউন্টারের কম্পিউটারে POS ইনস্টল করুন। এটি আপনার প্রোডাক্টের নিজস্ব কপি থেকে বিক্রি করে, তাই ইন্টারনেট ধীর হলেও বা না থাকলেও কাস্টমারকে দাঁড়িয়ে থাকতে হয় না।",
        summary: "অফলাইনে দ্রুত বিল, বাংলা রসিদ, রিটার্ন আর শিফটের ক্যাশ হিসাব।",
        blocks: {
            a: {
                title: "কাউন্টারে দ্রুত",
                body: "কিবোর্ড আর স্ক্যানারের জন্য বানানো, ভিড়ের সময়ের জন্য বড় বড় বাটন।",
                points: {
                    p1: "বারকোড স্ক্যান করুন, বা ইংরেজি বা বাংলায় নাম লিখে খুঁজুন",
                    p2: "একটি বিল হোল্ড রেখে পরের কাস্টমারকে দিন, পরে আবার খুলুন",
                    p3: "সীমার বেশি ছাড় দিতে ম্যানেজারের PIN লাগে",
                },
                alt: "{{brand}} ড্যাশবোর্ডে কাউন্টার আর অনলাইনের আজকের বিক্রি",
            },
            b: {
                title: "৭ দিন পর্যন্ত অফলাইন",
                body: "ইন্টারনেট গেলেও বিল, প্রিন্ট আর পেমেন্ট চলতে থাকে। নেট ফিরলে প্রতিটি বিল নিজে থেকেই সিঙ্ক হয় — ক্রমমতো, কখনো দুবার নয়।",
                points: {
                    p1: "যেকোনো থার্মাল প্রিন্টারে বাংলায় রসিদ",
                    p2: "রসিদের বারকোড থেকে রিটার্ন আর এক্সচেঞ্জ, অন্য ব্রাঞ্চের বিলও",
                    p3: "লোকাল ডেটা এনক্রিপ্টেড, প্রতি ঘণ্টায় ব্যাকআপ",
                },
                alt: "যে প্রোডাক্ট আর দামের কপি POS রাখে",
            },
            c: {
                title: "দিন শেষে ক্যাশের ভরসা",
                body: "প্রতিটি শিফট শুরু হয় হাতের ক্যাশ দিয়ে আর শেষ হয় না-দেখে ক্যাশ গুনে, তাই ঘাটতি থাকলে সেদিন সন্ধ্যাতেই ধরা পড়ে।",
                points: {
                    p1: "X আর Z রিপোর্ট, ক্যাশ ইন আর ক্যাশ আউট",
                    p2: "প্রতি শিফটে প্রত্যাশিত, গোনা আর পার্থক্য",
                    p3: "প্রতিটি কাউন্টারের বিক্রি অনলাইন অর্ডারের সাথে একই রিপোর্টে",
                },
                alt: "সব কাউন্টার সহ একটি বিক্রির রিপোর্ট",
            },
        },
    },
    "online-orders": {
        nav: "অনলাইন অর্ডার",
        metaDescription: "ফেসবুক, হোয়াটসঅ্যাপ, ফোন আর ওয়েবসাইটের অর্ডার এক তালিকায়; ভুয়া অর্ডার যাচাই, এক ক্লিকে স্টেডফাস্ট, পাঠাও বা রেডএক্স বুকিং আর COD মিলানো।",
        eyebrow: "অনলাইন অর্ডার ও কুরিয়ার",
        title: "ফেসবুকের মেসেজ থেকে কুরিয়ার পর্যন্ত এক জায়গায়",
        body: "ওয়েবসাইট, ফেসবুক, হোয়াটসঅ্যাপ আর ফোনের অর্ডার এক তালিকায় আসে, আর দোকানের কাউন্টারের মতো একই স্টক থেকে কমে।",
        summary: "সব চ্যানেলের অর্ডার এক তালিকায়, ভুয়া অর্ডার যাচাই, এক ক্লিকে কুরিয়ার আর COD মিলানো।",
        blocks: {
            a: {
                title: "সব অর্ডার এক তালিকায়",
                body: "ফেসবুক বা ফোনের অর্ডার কয়েক সেকেন্ডে লিখে ফেলুন; ওয়েবসাইটের অর্ডার নিজেই চলে আসে।",
                points: {
                    p1: "কনফার্ম, প্যাক আর শিপ — পরিষ্কার ধাপে",
                    p2: "অর্ডার আসার সাথে সাথেই স্টক আটকে রাখা হয়",
                    p3: "কাস্টমারের আগের অর্ডার আর রিটার্ন এক ট্যাপে",
                },
                alt: "ওয়েবসাইট আর ফেসবুকের অর্ডার একসাথে অর্ডার তালিকায়",
            },
            b: {
                title: "স্প্রেডশিট ছাড়াই কুরিয়ার আর COD",
                body: "অর্ডার থেকেই স্টেডফাস্ট, পাঠাও বা রেডএক্স বুক করুন, পার্সেল ট্র্যাক করুন, আর কুরিয়ারের প্রতিটি পেমেন্ট তার অর্ডারের সাথে মিলিয়ে নিন।",
                points: {
                    p1: "ঠিকানা আগে থেকেই বসানো, এক ক্লিকে বুকিং",
                    p2: "ডেলিভারির অবস্থা নিজে থেকেই আপডেট হয়",
                    p3: "প্রতি কুরিয়ারে আদায় হওয়া COD, চার্জ আর বাকি টাকা",
                },
                alt: "কুরিয়ারের পেমেন্টের সাথে মিলানো ক্যাশ অন ডেলিভারি",
            },
            c: {
                title: "ভুয়া অর্ডার কমান",
                body: "পাঠানোর আগে দেখুন এই নম্বর থেকে কতবার অর্ডার হয়েছে, কতবার নিয়েছে আর কতবার ফেরত দিয়েছে — যারা কখনো টাকা দেয় না তাদের ব্লক করুন।",
                points: {
                    p1: "নম্বরের অর্ডারের ইতিহাস থেকে ঝুঁকির স্কোর",
                    p2: "বারবার পার্সেল ফেরত দেওয়া নম্বরের ব্লকলিস্ট",
                    p3: "চাইলে চেকআউটে ওয়ান-টাইম কোড",
                },
                alt: "দোকানের নিজের ওয়েবসাইটে একটি প্রোডাক্ট পেজ",
            },
        },
    },
    inventory: {
        nav: "স্টক ও ব্রাঞ্চ",
        metaDescription: "সব ব্রাঞ্চ, গুদাম, কাউন্টার আর ওয়েবসাইটের জন্য একটাই স্টক: ট্রান্সফার, স্টক গণনা, পারচেজ অর্ডার আর প্রতিটি পরিবর্তনের পুরো ইতিহাস।",
        eyebrow: "স্টক ও ব্রাঞ্চ",
        title: "একটাই স্টক, সব জায়গায় ঠিক",
        body: "প্রতিটি বিক্রি, রিটার্ন, কেনা আর ট্রান্সফার একই স্টক বদলায়, তাই শেষ পিসটি কখনো দুবার বিক্রি হয় না আর প্রতিটি ব্রাঞ্চ জানে তার কাছে কী আছে।",
        summary: "ব্রাঞ্চভিত্তিক লাইভ স্টক, ট্রান্সফার, গণনা আর কেনাকাটা, পুরো ইতিহাস সহ।",
        blocks: {
            a: {
                title: "সব ব্রাঞ্চ এক স্ক্রিনে",
                body: "প্রতিটি ব্রাঞ্চ, গুদাম আর কাউন্টারে এই মুহূর্তে কী আছে, আর কতটা অর্ডারের জন্য আটকে আছে — দেখুন।",
                points: {
                    p1: "সাইজ, রং আর অন্যান্য ভ্যারিয়েন্ট, প্রত্যেকটির আলাদা স্টক",
                    p2: "শেষ হওয়ার আগেই কম স্টকের সতর্কবার্তা",
                    p3: "প্রতিটি পরিবর্তনের ইতিহাস: কে, কখন আর কেন",
                },
                alt: "সব ব্রাঞ্চে প্রতিটি প্রোডাক্টের স্টক",
            },
            b: {
                title: "দোকান বন্ধ না করেই সরান আর গুনুন",
                body: "অন্য ব্রাঞ্চে স্টক পাঠান আর সেখানে গ্রহণ করুন; দোকানে বিক্রি চলতে চলতেই তাক গুনে ফেলুন।",
                points: {
                    p1: "পাঠানো আর গ্রহণের ধাপ সহ ট্রান্সফার",
                    p2: "গণনার সময়ের বিক্রিও হিসাবে ধরে স্টক গণনা",
                    p3: "কারণ সহ অ্যাডজাস্টমেন্ট, অনুমোদনের পরেই কার্যকর",
                },
                alt: "দাম আর স্টক সহ প্রোডাক্ট তালিকা",
            },
            c: {
                title: "হিসাব সামনে রেখে সাপ্লায়ার থেকে কিনুন",
                body: "পারচেজ অর্ডার দিন, তার বিপরীতে মাল গ্রহণ করুন আর জানুন কোন সাপ্লায়ারের কাছে কত বাকি।",
                points: {
                    p1: "পারচেজ অর্ডার আর মাল গ্রহণ",
                    p2: "সাপ্লায়ারের বাকি আর পেমেন্ট",
                    p3: "এইমাত্র আসা মালের বারকোড লেবেল",
                },
                alt: "একই গণনার স্টক সহ দোকানের ওয়েবসাইটে একটি প্রোডাক্ট",
            },
        },
    },
    storefront: {
        nav: "আপনার ওয়েবসাইট",
        metaDescription: "বাংলাদেশের জন্য বানানো ১২টি ডিজাইনের একটিতে নিজের অনলাইন দোকান: নিজের ডোমেইন, ক্যাশ অন ডেলিভারি, বিকাশ আর নগদ, ল্যান্ডিং পেজ আর ফেসবুক পিক্সেল — দোকানের একই স্টকে।",
        eyebrow: "আপনার নিজের ওয়েবসাইট",
        title: "একই স্টক থেকে বিক্রি করা দোকানের ওয়েবসাইট",
        body: "একটি ডিজাইন বাছুন, লোগো আর রং দিন, প্রকাশ করুন। প্রোডাক্ট, দাম আর স্টক সিস্টেম থেকেই আসে — কিছু কপি করতে হয় না।",
        summary: "১২টি ডিজাইন, নিজের ডোমেইন, COD, বিকাশ আর নগদ, একই স্টকে।",
        blocks: {
            a: {
                title: "বাংলাদেশি দোকানের জন্য ১২টি ডিজাইন",
                body: "ফ্যাশন, মুদি, গ্যাজেট, বই, বিউটি আর আরও অনেক — প্রত্যেকটি ফোনে দ্রুত, বাংলা আর ইংরেজিতে তৈরি।",
                points: {
                    p1: "আপনার লোগো, রং, ব্যানার আর মেনু",
                    p2: "নিজের ডোমেইন, বা শুরুতে একটি ফ্রি ঠিকানা",
                    p3: "যেকোনো সময় ডিজাইন বদলান, কিছু হারাবে না",
                },
                alt: "{{brand}} অ্যাডমিনে থিম বাছাই",
            },
            b: {
                title: "কাস্টমার যেভাবে টাকা দেয়, সেভাবেই চেকআউট",
                body: "ক্যাশ অন ডেলিভারি, বিকাশ আর নগদ, এলাকা অনুযায়ী ডেলিভারি চার্জ, আর কম দামি ফোনেও চলা অর্ডার ফর্ম।",
                points: {
                    p1: "ঢাকার ভেতরে আর বাইরে আলাদা ডেলিভারি চার্জ",
                    p2: "অফার, কুপন আর ফ্রি ডেলিভারির নিয়ম",
                    p3: "অর্ডারের ইতিহাস সহ কাস্টমার অ্যাকাউন্ট",
                },
                alt: "{{brand}} দিয়ে বানানো একটি ফ্যাশন দোকানের হোম পেজ",
            },
            c: {
                title: "আপনার ফেসবুক বিজ্ঞাপনের জন্য তৈরি",
                body: "একটি প্রোডাক্টের ল্যান্ডিং পেজ, আর বিজ্ঞাপন থেকে কত বিক্রি হলো মাপতে ফেসবুক পিক্সেল ও কনভার্সন API।",
                points: {
                    p1: "পেজের মধ্যেই অর্ডার ফর্ম সহ ল্যান্ডিং পেজ",
                    p2: "ফেসবুক পিক্সেল, কনভার্সন API আর গুগল অ্যানালিটিক্স",
                    p3: "সার্চ ইঞ্জিন আপনার প্রোডাক্ট খুঁজে পায়",
                },
                alt: "গ্যাজেট থিমে একটি প্রোডাক্ট পেজ",
            },
        },
    },
    accounts: {
        nav: "হিসাব ও রিপোর্ট",
        metaDescription: "দিন, ব্রাঞ্চ আর চ্যানেল অনুযায়ী লাভ-ক্ষতি, ক্যাশবুক, খরচ, সাপ্লায়ারের বাকি, COD মিলানো আর ভ্যাট ইনভয়েস — প্রতিটি বিক্রি থেকে নিজেই যোগ হয়।",
        eyebrow: "হিসাব ও রিপোর্ট",
        title: "আজ কত আয় হলো, জেনে নিন",
        body: "প্রতিটি বিক্রি, রিটার্ন, খরচ আর কুরিয়ারের পেমেন্ট ঘটার সাথে সাথেই লেখা হয়, তাই আপনি যখন দেখবেন, হিসাব তৈরি থাকে।",
        summary: "সব চ্যানেলের লাভ, ক্যাশ, খরচ, COD আর ভ্যাট — সন্ধ্যার যোগ-বিয়োগ ছাড়াই।",
        blocks: {
            a: {
                title: "শুধু বিক্রি নয়, লাভ",
                body: "মালের দাম বাদ দিয়ে কত আয় হলো দেখুন — দিন, ব্রাঞ্চ বা চ্যানেল অনুযায়ী।",
                points: {
                    p1: "যেকোনো সময়ের লাভ-ক্ষতি",
                    p2: "বেশি বিক্রি আর ধীরে বিক্রি হওয়া প্রোডাক্ট",
                    p3: "প্রতিটি রিপোর্ট এক্সেলে নেওয়া যায়",
                },
                alt: "একটি লাভ-ক্ষতির রিপোর্ট",
            },
            b: {
                title: "প্রতিটি টাকার একটা জায়গা আছে",
                body: "ক্যাশ ড্রয়ার, ব্যাংক অ্যাকাউন্ট আর বিকাশ বা নগদ ওয়ালেট — প্রত্যেকটির আলাদা ব্যালেন্স; এক ধাপে টাকা সরান।",
                points: {
                    p1: "ক্যাশবুক আর খরচ",
                    p2: "সাপ্লায়ারের বাকি আর কাস্টমারের বাকি",
                    p3: "কুরিয়ারের আদায় করা COD, অর্ডারের সাথে মিলানো",
                },
                alt: "অর্ডারের সাথে মিলানো কুরিয়ারের COD",
            },
            c: {
                title: "ভ্যাট আর হিসাবরক্ষকের জন্য তৈরি",
                body: "বিক্রিতে ভ্যাট ইনভয়েস আর সময়ভিত্তিক ভ্যাট রিপোর্ট; রসিদের ব্যাগের বদলে পরিষ্কার হিসাব দিন।",
                points: {
                    p1: "ভ্যাট ইনভয়েস আর ভ্যাট রিপোর্ট",
                    p2: "চ্যানেল, ব্রাঞ্চ আর প্রোডাক্ট অনুযায়ী বিক্রি",
                    p3: "কে কী বদলেছে, তার পুরো অডিট ট্রেইল",
                },
                alt: "দিন আর চ্যানেল অনুযায়ী বিক্রির রিপোর্ট",
            },
        },
    },
    ebooks: {
        nav: "ই-বুক",
        metaDescription: "ছাপা বইয়ের পাশে ই-বুক বিক্রি করুন: ফ্রি নমুনা, বিকাশে পেমেন্ট, প্রতিটি কাস্টমারের পড়ার লাইব্রেরি আর ওয়াটারমার্ক করা পাতা — বইঘর ডিজাইনে।",
        eyebrow: "ই-বুক ও ডিজিটাল প্রোডাক্ট",
        title: "ছাপা বইয়ের পাশেই ই-বুক বিক্রি করুন",
        body: "একটি বইয়ের আরেকটি সংস্করণ হিসেবে ই-বুক যোগ করুন। কাস্টমার অনলাইনে টাকা দিয়ে সাথে সাথেই নিজের লাইব্রেরিতে পড়তে পারেন।",
        summary: "ছাপা বইয়ের পাশে ই-বুক, নমুনা, অনলাইন পেমেন্ট আর পড়ার লাইব্রেরি সহ।",
        blocks: {
            a: {
                title: "বাংলা বইয়ের জন্য বানানো বইয়ের দোকানের ডিজাইন",
                body: "লেখক, প্রকাশক আর ক্যাটাগরি, সুন্দরভাবে পড়া যায় এমন বাংলা শিরোনাম, আর ছাপা ও ই-বুক সংস্করণ পাশাপাশি।",
                points: {
                    p1: "একটি বইয়ের ছাপা আর ই-বুক সংস্করণ",
                    p2: "ফ্রি নমুনা অধ্যায়",
                    p3: "লেখক আর প্রকাশকের পেজ",
                },
                alt: "বইঘর ডিজাইনের হোম পেজ",
            },
            b: {
                title: "অনলাইনে পেমেন্ট, সাথে সাথেই পড়া",
                body: "কাস্টমার বিকাশে টাকা দেন, আর বইটি তার লাইব্রেরিতে চলে আসে — ফোনে বা কম্পিউটারে পড়ার জন্য তৈরি।",
                points: {
                    p1: "শেষ পড়া পাতা মনে রাখা নিজস্ব লাইব্রেরি",
                    p2: "ফোন নম্বর বা গুগল দিয়ে সাইন ইন",
                    p3: "ছাপা বই একই অর্ডারে কুরিয়ারে যায়",
                },
                alt: "ছাপা আর ই-বুক সংস্করণ সহ একটি বইয়ের পেজ",
            },
            c: {
                title: "সহজে কপি করা থেকে সুরক্ষিত",
                body: "বই রিডারে খোলে, পাঠানোর মতো ফাইল হিসেবে নয়, আর প্রতিটি পাতায় ক্রেতার নিজের ওয়াটারমার্ক থাকে।",
                points: {
                    p1: "অল্প সময়ের লিংক, কখনো পাবলিক ফাইল নয়",
                    p2: "ওয়াটারমার্ক করা নমুনা আর পাতা",
                    p3: "কোন বই কখন খোলা হলো তার রেকর্ড",
                },
                alt: "{{brand}} প্রোডাক্ট তালিকায় বই",
            },
        },
    },
};
//# sourceMappingURL=web-features.js.map